import { render } from "./SkillItem.vue?vue&type=template&id=b60903b4&scoped=true"
import script from "./SkillItem.vue?vue&type=script&lang=js"
export * from "./SkillItem.vue?vue&type=script&lang=js"

import "./SkillItem.vue?vue&type=style&index=0&id=b60903b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b60903b4"]])

export default __exports__